import React from 'react';
import bannerParceiro from '../../assets/seu-parceiro.jpeg';
import './Banner.css';

const Banner = () => {
  return (
    <section className="banner">
      <img
        src={bannerParceiro}
        alt="Seu parceiro na jornada empresarial"
      />
    </section>
  );
};

export default Banner;
